import React from 'react'
import ResetPasswordComponent from '../Components/ResetPasswordComponent'
import { LandingHeader } from '../../LandingScreens/Components/LandingHeader'

function ResetPasswordPage() {
  return (
    <div>
      <LandingHeader />
      <ResetPasswordComponent />
    </div>
  )
}

export default ResetPasswordPage
